export default __webpack_public_path__ + "static/endast-svenska-casino-med-casinolabbet-cd4a11d514d752bea3ee301e5f20be06.jpg";